export const MIN_VIEWPORT_SCALE = 0.5;
export const MAX_VIEWPORT_SCALE = 5;
export const MIN_PDF_VIEWPORT_SCALE = 0.05;
export const MAX_PDF_VIEWPORT_SCALE = 20;

export const clampViewportScale = (
  value: number,
  minimum = MIN_VIEWPORT_SCALE,
  maximum = MAX_VIEWPORT_SCALE,
): number => {
  const lower = Math.min(minimum, maximum);
  const upper = Math.max(minimum, maximum);
  return Math.min(upper, Math.max(lower, value));
};

export const clampPdfViewportScale = (value: number): number =>
  clampViewportScale(
    value,
    MIN_PDF_VIEWPORT_SCALE,
    MAX_PDF_VIEWPORT_SCALE,
  );

export interface ViewportZoomTransform {
  scale: number;
  position: { x: number; y: number };
}

export const zoomViewportAtPoint = (
  position: { x: number; y: number },
  currentScale: number,
  nextScale: number,
  anchor: { x: number; y: number },
): ViewportZoomTransform => {
  if (
    !Number.isFinite(currentScale) ||
    currentScale <= 0 ||
    !Number.isFinite(nextScale) ||
    nextScale <= 0
  ) {
    return { scale: currentScale, position };
  }
  const contentX = (anchor.x - position.x) / currentScale;
  const contentY = (anchor.y - position.y) / currentScale;
  return {
    scale: nextScale,
    position: {
      x: anchor.x - contentX * nextScale,
      y: anchor.y - contentY * nextScale,
    },
  };
};
